import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportRegistrationSummaryComponent } from './component/transport-registration-summary.component';
import { MaterialModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonUIModule, CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TransportRegistrationSummaryComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,
  ]
})
export class TransportRegistrationSummaryModule { }
